const AttributeHiddenComponent = () => {
  return null
}

export default AttributeHiddenComponent
